// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__vSyGv","messages":"Chat_messages__2gebR","dateDivider":"Chat_dateDivider__n5_3l"};